import { CreateOptionGroupRequest } from 'src/api/createOptionGroup';
import { IOptionGroupItem, IOptionGroupValues } from '../../types';
import { EntitySource } from 'src/constants';
import { CreateOptionGroupRequestOption } from '../../../../api/createOptionGroup/types';

const formatCreateOptionGroupRequest = (
  data: IOptionGroupValues,
  itemIds: string[],
  priceSchemeIds: string[],
): CreateOptionGroupRequest => {
  return {
    type: data.optionGroupType,
    name: data.name,
    consumer_name: data.consumer_name || null,
    description: data.description,
    plu: data.plu || null,
    min_choices: data.min_choices,
    max_choices: data.max_choices,
    ranges: data.source === EntitySource.RANGES && data.ranges ? data.ranges : [],
    options: data.modifiers.map((modifier: IOptionGroupItem): CreateOptionGroupRequestOption => {
      return {
        item_id: modifier.parentItemId || modifier.optionItemId,
        plu: modifier.inheritPosId ? null : modifier.posId || null,
        value_with_tax: modifier.useDefaultPrice ? null : modifier.valueWithTax,
        min_choices: modifier.min ?? null,
        max_choices: modifier.max ?? null,
        default_choice: modifier.default ?? null,
      };
    }),
    external_systems: data.externalSystems,
    item_ids: itemIds,
    price_scheme_ids: priceSchemeIds,
  };
};

export default formatCreateOptionGroupRequest;
